import { Button } from "@/components/ui/button";
import { DeleteContactButton } from "@/components/admin/DeleteContactButton";
import { useNavigate } from "react-router-dom";

interface FormActionsProps {
  isNewEmployee: boolean;
  employeeId?: string;
  saving: boolean;
}

export const FormActions = ({ isNewEmployee, employeeId, saving }: FormActionsProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center pt-4">
      {!isNewEmployee && <DeleteContactButton userId={employeeId || ''} />}
      <div className="space-x-2">
        <Button
          type="button"
          variant="outline"
          onClick={() => navigate("/admin/employees")}
        >
          Cancel
        </Button>
        <Button type="submit" disabled={saving}>
          {saving ? "Saving..." : (isNewEmployee ? "Create Employee" : "Save Changes")}
        </Button>
      </div>
    </div>
  );
};